import React, { useState, useEffect, CSSProperties } from "react";
import cn from "classnames";
import OutsideClickHandler from "react-outside-click-handler";
import styles from "./DropdownKeywords.module.sass";

import Search from "../Search";
import {
  Box,
  Breakpoint,
  CircularProgress,
  Typography,
  useTheme,
} from "@mui/material";
import { CrossIconSvg } from "../../../assets/icons/CrossIconSvg";
import Tooltip from "../Tooltip";
import CheckboxInput from "../CheckboxInput";

type Props = {
  className?: any;
  classDropdownHead?: any;
  classDropdownLabel?: any;
  classDropdownBody?: any;
  classDropdownOption?: any;
  classSelectedValueStyles?: any;
  classChipContainerStyle?: any;
  value?: any;
  setValue?: any;
  optionsList?: any;
  setOptionsList?: any;
  label?: any;
  tooltip?: any;
  small?: any;
  upBody?: any;
  handlechangeVal?: any;
  placeholder?: any;
  onClick?: any;
  required?: boolean;
  isEditForm?: any;
  loading?: boolean;
  // selectedKeywordsContainer?: CSSProperties;
  selectedKeywordsContainer?: {
    [key in Breakpoint]?: string;
  };
  optionsBodyStyles?: CSSProperties;
  focus?: boolean;
  props?: any[];
  searchBoxStyles?: CSSProperties;
  selectedOptionColor?: any;
  optionsDefaultColor?: any;
};

const DropdownMultiSelect: React.FC<Props> = ({
  className,
  classDropdownHead,
  classDropdownLabel,
  classDropdownBody,
  classDropdownOption,
  classSelectedValueStyles,
  classChipContainerStyle,
  value,
  setValue,
  optionsList,
  setOptionsList,
  label,
  tooltip,
  small,
  upBody,
  handlechangeVal,
  placeholder,
  onClick,
  isEditForm,
  selectedKeywordsContainer,
  required,
  loading,
  optionsBodyStyles,
  focus,
  searchBoxStyles,
  selectedOptionColor,
  optionsDefaultColor,
  ...props
}) => {
  const theme = useTheme();
  const [visible, setVisible] = useState(false);
  const [isFocused, setIsFocused] = useState<boolean>(false);

  const [searchText, setSearchText] = useState("");

  // const handleClick = (clickedVal: any, i: any) => {
  //   const clickedId = clickedVal[0]?.id;

  //   // Check if the clicked option is already in the selected values
  //   const isSelected = value?.some((item: any) => item?.id === clickedId);

  //   if (isSelected) {
  //     // If already selected, remove it
  //     setValue(value.filter((item: any) => item?.id !== clickedId));
  //   } else {
  //     // If not selected, add it to the selected values
  //     setValue([...value, { id: clickedId, name: clickedVal[0]?.name }]);
  //   }

  //   // Toggle the selected state in the optionsList list
  //   const updatedOptions = optionsList?.map((option: any, index: any) => {
  //     if (index === i) {
  //       return { ...option, selected: !option.selected };
  //     }
  //     return option;
  //   });

  //   setOptionsList(updatedOptions);
  // };

  // detect mode (string array ya object array)
  const isStringMode = typeof optionsList[0] === "string";

  // normalize options
  const safeOptions = (optionsList || []).map((item: any, idx: number) =>
    typeof item === "string" ? { id: item, name: item } : item
  );

  // normalize value
  const safeValue = (Array.isArray(value) ? value : []).map((item: any) =>
    typeof item === "string" ? { id: item, name: item } : item
  );

  const handleClick = (clickedVal: any) => {
    const isSelected = safeValue?.some(
      (item: any) => item?.id === clickedVal?.id
    );

    let updated;
    if (isSelected) {
      updated = safeValue.filter((item: any) => item?.id !== clickedVal?.id);
    } else {
      updated = [...safeValue, { id: clickedVal.id, name: clickedVal.name }];
    }

    // return in same format as input
    if (isStringMode) {
      setValue?.(updated.map((i: any) => i.name)); // string array
    } else {
      setValue?.(updated); // object array
    }
  };

  useEffect(() => {}, [safeValue, optionsList]);

  useEffect(() => {
    if (focus !== undefined && focus !== null) {
      setIsFocused(focus);
    } else {
      setIsFocused(false);
    }
  }, []);

  return (
    <OutsideClickHandler onOutsideClick={() => setVisible(false)}>
      {label && (
        <div className={cn(styles.label, classDropdownLabel)}>
          <Box sx={{ display: "flex", alignItems: "center", gap: "2px" }}>
            {label}{" "}
            {required && <Typography sx={{ color: "red" }}>*</Typography>}
          </Box>
          {tooltip && (
            <Tooltip
              className={styles.tooltip}
              title={tooltip}
              icon="info"
              place="right"
            />
          )}
        </div>
      )}
      <Box
        className={cn(
          styles.dropdown,
          className,
          { [styles.small]: small },
          {
            [styles.active]: visible,
          }
        )}
      >
        <Box
          sx={{
            // border: focus ? "1.6px solid #80c242" : "1.6px solid #E9EAEC",
            ":focus": {
              // border: "1.6px solid #80c242",
              outline: "none",
            },
          }}
          tabIndex={0}
          className={cn(styles.head, classDropdownHead)}
          onClick={() => setVisible(!visible)}
          onFocus={() => setIsFocused(true)}
          onBlur={() => setIsFocused(false)}
        >
          <Box
            sx={{
              [theme.breakpoints.up("xs")]: {
                maxWidth: selectedKeywordsContainer?.xs,
              },
              [theme.breakpoints.up("sm")]: {
                maxWidth: selectedKeywordsContainer?.sm,
              },
              [theme.breakpoints.up("md")]: {
                maxWidth: selectedKeywordsContainer?.md,
              },
              [theme.breakpoints.up("lg")]: {
                maxWidth: selectedKeywordsContainer?.lg,
              },
              overflowX: "scroll",
            }}
            className={`${styles.selection} ${classSelectedValueStyles} HideScrollbar`}
          >
            {safeValue?.length > 0 ? (
              safeValue?.map((keyword: any, i: any) => {
                return (
                  <Box
                    key={i}
                    className={`${styles.selectedKeywordContainer} ${classChipContainerStyle}`}
                    // className={styles.selectedKeywordContainer classChipContainerStyle}
                  >
                    <Typography
                      fontWeight={500}
                      variant="body2"
                      className={styles?.selectedKeyword}
                    >
                      {keyword?.name}
                    </Typography>
                    <Box
                      onClick={(e) => {
                        e.stopPropagation();
                        setValue(
                          safeValue.filter(
                            (item: any) => item?.id !== keyword?.id
                          )
                        );
                      }}
                      id={keyword?.id}
                      sx={{
                        marginLeft: "7px",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        opacity: "70%",
                        "&:hover": { opacity: "100%" },
                      }}
                    >
                      <CrossIconSvg color="#FFFFFF" />
                    </Box>
                  </Box>
                );
              })
            ) : (
              <Box>
                <Typography
                  fontWeight={300}
                  sx={{ zIndex: 1, color: "#FFFFFF", fontSize: "16px" }}
                  variant="body2"
                >
                  {placeholder || "Select"}
                </Typography>
              </Box>
            )}
          </Box>
        </Box>
        <Box
          className={cn(
            styles.body,
            { [styles.bodyUp]: upBody },
            classDropdownBody,
            "HideScrollbar"
          )}
          sx={{ zIndex: "1000000", display: "flex", flexDirection: "column" }}
        >
          <Box sx={{ height: "48px" }}>
            <Search
              style={{
                padding: "12px 12px 12px 43px",
                fontSize: "14px",
                minWidth: "auto",
                backgroundColor: "#ECECEC",
                height: "48px",
                ...searchBoxStyles,
              }}
              value={searchText}
              searchFormStyles={{
                minWidth: "auto !important",
                marginBottom: "8px",
              }}
              placeholder="Search"
              onChange={(e) => {
                setSearchText(e.target.value);
              }}
            />
          </Box>
          {loading ? (
            <Box
              sx={{
                width: "100%",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                height: "100%",
              }}
            >
              <CircularProgress
                size={24}
                sx={{
                  color: "white",
                  marginRight: "12px",
                }}
              />
            </Box>
          ) : (
            <Box
              className="HideScrollbar"
              sx={{
                overflowY: "scroll",
                flex: "1",
                ...optionsBodyStyles,
              }}
            >
              {
                // [
                //   ...new Map(
                //     optionsList?.map((item: any) => [item["id"], item])
                //   ).values(),
                // ]
                [
                  ...Array.from(
                    new Map(
                      // optionsList?.map((item: any) => [item["id"], item])
                      safeOptions?.map((item: any) => [item["id"], item])
                    ).values()
                  ),
                ]
                  ?.filter((item: any) => {
                    const searchValues =
                      item?.name
                        ?.toLowerCase()
                        ?.includes(searchText?.toLowerCase()) ||
                      searchText === "";
                    return searchValues || searchText === "";
                  })
                  ?.map((optionValue: any, index) => {
                    const isSelected = safeValue?.some(
                      (elem: any) => elem?.id === optionValue?.id
                    );

                    return (
                      <Box
                        onClick={() => handleClick(optionValue)}
                        className={cn(
                          styles.option,
                          classDropdownOption,
                          {
                            [styles.selectioned]: isSelected,
                          },
                          "HideScrollbar"
                        )}
                        key={index}
                        id={optionValue?.id}
                        // placeholder={placeholder}
                        sx={{
                          color: isSelected
                            ? selectedOptionColor
                            : optionsDefaultColor,
                        }}
                        {...props}
                      >
                        <Box
                          sx={{
                            display: "flex",
                            gap: "10px",
                            alignItems: "center",
                          }}
                        >
                          <CheckboxInput
                            id={optionValue?.id}
                            // onChange={() => handleClick([optionValue], index)}
                            onChange={() => handleClick(optionValue)}
                            value={isSelected}
                          />
                          <Typography fontWeight={500} variant="body2">
                            {optionValue?.name ? optionValue?.name : ""}
                          </Typography>
                        </Box>
                      </Box>
                    );
                  })
              }
            </Box>
          )}
        </Box>
      </Box>
    </OutsideClickHandler>
  );
};

export default DropdownMultiSelect;
